import { createAction, props } from '@ngrx/store';

export const getCustomMenu = createAction('[custom-menu] get menu entries');
export const getCustomMenuSuccess = createAction('[custom-menu] get menu entries success', props<{ data: any }>());
export const getCustomMenuFailure = createAction('[custom-menu] get menu entries failiure', props<{ error: Error }>());
